import $ from "/srv/www/f/friesland-boating.nl/vhosts/www/htdocs/wp-content/plugins/wp-soup-framework/node_modules/jquery";

$(document).ready(function () {
  $(".article-date").insertAfter(".wp-block-acf-breadcrumbs");

  $(".exclusive-price").click(function () {
    $(".panels").removeClass("is-active");
    $(".ms-tabs").removeClass("is-active");
    $(".exclusive-tab").addClass("is-active");
    $(".ms-tabs-sevice").addClass("is-active");
  });
  var galleryThumbs = new Swiper(".ms_boat-gallery-thumbs", {
    spaceBetween: 10,
    slidesPerView: 4,
    loop: true,
    freeMode: true,
    loopedSlides: 5, // looped slides should be the same
    navigation: {
      nextEl: ".ms_boat-thumbnail-swiper-button-next",
      prevEl: ".ms_boat-thumbnail-swiper-button-prev",
    },
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
  });
  var galleryTop = new Swiper(".ms_boat-gallery-top", {
    spaceBetween: 10,
    loop: true,
    loopedSlides: 5, // looped slides should be the same
    navigation: {
      nextEl: ".ms_boat-swiper-button-next",
      prevEl: ".ms_boat-swiper-button-prev",
    },
    thumbs: {
      swiper: galleryThumbs,
    },
  });

  /**
   * Register click events for all calendar links
   */
  function registerCalendarLinks() {
    registerScrollOnClick("addlink", "addperiodes", registerBoekenLinks);
  }
  registerCalendarLinks();

  /**
   *
   *
   * register click events in boeken links
   */
  function registerBoekenLinks() {
    registerScrollOnClick("xaddlink", "rental", registerCustomerInfo);
  }

  /**
   * register click events in customer info
   */
  function registerCustomerInfo() {
    registerScrollOnClick("button_verder", "rental");
  }

  /**
   * Register a click event that will scroll to a given element
   * @param string from_class which classes can be clicked
   * @param string to_id where to scroll to
   * @param function|null on_finish optional what to do on finish besides scrolling
   */
  function registerScrollOnClick(from_class, to_id, on_finish = null) {
    const elements = document.getElementsByClassName(from_class);
    // if not empty
    if (elements.length > 0) {
      Array.from(elements).forEach((element) => {
        element.addEventListener("click", () => {
          scrollToSmooth(to_id);
          if (on_finish) {
            on_finish();
          }
        });
      });
    } else {
      window.setTimeout(() => {
        registerScrollOnClick(from_class, to_id, on_finish);
      }, 100);
    }
  }

  /**
   * Scroll to id, smoothly
   * @param string id
   */
  function scrollToSmooth(id) {
    const element = document.getElementById(id);
    if (element) {
      // how far extra it has to scroll up:
      const offset = 80;
      const body_pos = document.body.getBoundingClientRect().top;
      const element_pos = element.getBoundingClientRect().top;

      window.scrollTo({
        top: element_pos - body_pos - offset,
        behavior: "smooth",
      });
    } else {
      window.setTimeout(() => {
        scrollToSmooth(id);
      }, 100);
    }
  }

  if (document.getElementById("boeken_wrapper")) {
    $("#boeken_wrapper .stappen ul li").wrapInner("<span />");

    document
      .getElementById("boeken_wrapper")
      .addEventListener("DOMSubtreeModified", LocalMain, false);
    function LocalMain() {
      document
        .getElementById("boeken_wrapper")
        .removeEventListener("DOMSubtreeModified", LocalMain);

      if ($("#boeken_wrapper .stappen ul li").children("span").length === 0) {
        $("#boeken_wrapper .stappen ul li").wrapInner("<span />");
      }

      document
        .getElementById("boeken_wrapper")
        .addEventListener("DOMSubtreeModified", LocalMain, false);
    }
  }
});
